/**
 * Set this to true if somebody complains that they need to use the "Approve for specific networks" button
 * Number of times this feature was brought back to life: 2 (increase this counter the next time we toggle this feature on, just for fun)
 * @see https://perion.atlassian.net/browse/HV-9774
 */
export const ENABLE_APPROVE_FOR_SPECIFIC_INVENTORY = true;
